/**
 * OS ErrorBoundary — WebOS pencere içi hata yakalama
 * Pencere çökerse sadece o pencere hata gösterir, OS çökmez
 */
import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props { children: ReactNode; windowId?: string }
interface State { hasError: boolean; error?: Error }

export default class ErrorBoundaryOS extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(`[OS Error] ${this.props.windowId || 'unknown'}:`, error, info.componentStack?.slice(0, 200))
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        height: '100%', padding: 24, textAlign: 'center', color: 'var(--os-text)',
      }}>
        <div style={{ fontSize: 32, marginBottom: 12 }}>⚠️</div>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>Bu pencerede hata oluştu</div>
        <div style={{ fontSize: 11, color: 'var(--os-muted)', marginBottom: 16, maxWidth: 280 }}>
          {this.state.error?.message?.slice(0, 100) || 'Bilinmeyen hata'}
        </div>
        <button onClick={() => this.setState({ hasError: false, error: undefined })} style={{
          padding: '8px 16px', background: 'rgba(99,102,241,0.15)', border: '1px solid rgba(99,102,241,0.3)',
          borderRadius: 8, color: '#818cf8', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit',
        }}>Tekrar Dene</button>
      </div>
    )
  }
}
